import { getParentWindow } from '@shared/lib/getParentWindow';

export const AWS_REGION = process.env['REACT_APP_AWS_REGION'];
export const AWS_USER_POOL_ID = process.env['REACT_APP_AWS_USER_POOL_ID'];
export const AWS_USER_POOL_WEB_CLIENT_ID = process.env['REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID'];
export const AWS_COOKIE_DOMAIN = process.env['REACT_APP_AWS_COOKIE_DOMAIN'];

export const AWS_AMPLIFY_CONFIG = Object.freeze({
  Auth: {
    Cognito: {
      userPoolId: AWS_USER_POOL_ID,
      userPoolClientId: AWS_USER_POOL_WEB_CLIENT_ID,
    },
  },
});

export const LauncherTokenStorage = getParentWindow().localStorage;

const AmplifyV6MigrationKey = 'nucleus.amplify.v6.migrated';

export function clearStaleAmplifyV5Tokens(storage) {
  if (storage.getItem(AmplifyV6MigrationKey)) {
    return;
  }

  const keysToRemove = [];
  for (let index = 0; index < storage.length; index++) {
    const storageKey = storage.key(index);
    if (storageKey && storageKey.includes('CognitoIdentityServiceProvider')) {
      keysToRemove.push(storageKey);
    }
  }
  keysToRemove.forEach((storageKey) => storage.removeItem(storageKey));
  storage.setItem(AmplifyV6MigrationKey, 'true');
}

export const LOGIN_EMAIL_STATUS = {
  LOGIN: 'Login',
  SIGNUP: 'Sign Up',
  NOSIGNUP: 'Cannot Sign Up',
  PASSWORDRESET: 'Password Reset',
};
